module.exports = __webpack_public_path__ + "img/user.aa2adba8.svg";